module.exports = __webpack_public_path__ + "static/eatella-foodstagram-app-6408000529e8a7dcefdee0e6bd818424.jpg";